module.exports = __webpack_public_path__ + "bda35c62e9ba99c74fb03a54d3e4a236.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BR.svg
// module id = Uocv
// module chunks = 0